import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Tick } from 'component/BuyersMarketplace/MakeOffers';
import React, { useEffect, useState } from 'react';

const LockSign = ({ color, size }) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      class="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M536.417 574.066h-55.844c-25.701 0-46.536 20.835-46.536 46.536s20.835 46.536 46.536 46.536h9.307V797.44c0 10.281 8.334 18.615 18.615 18.615 10.281 0 18.614-8.334 18.614-18.615V667.139h9.307c25.701 0 46.536-20.835 46.536-46.536 0.001-25.702-20.834-46.537-46.535-46.537z m251.296-165.878v-1.653h-3.701c-27.37-11.963-57.592-18.615-89.372-18.615H322.35c-0.739 0-1.473 0.021-2.21 0.028h-16.557v-51.477c0-125.808 100.075-227.797 223.527-227.797 115.83 0 211.078 89.786 222.397 204.788h37.144C774.79 177.815 663.13 71.474 527.11 71.474c-143.927 0-260.603 119.057-260.603 265.921v57.563C170.164 419.756 98.976 507.212 98.976 611.295v130.302c0 123.366 100.008 223.374 223.374 223.374h372.29c123.366 0 223.374-100.008 223.374-223.374V611.295c0.001-90.147-53.406-167.812-130.301-203.107z m93.073 296.18c0 123.366-100.008 223.374-223.374 223.374H359.579c-123.366 0-223.374-100.008-223.374-223.374v-55.844c0-123.366 100.008-223.374 223.374-223.374h297.832c123.366 0 223.374 100.008 223.374 223.374v55.844z"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};

const TickSign = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M4.89163 13.2687L9.16582 17.5427L18.7085 8"
          stroke="#03aa49"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
      </g>
    </svg>
  );
};

const WrongSign = ({ size }) => {
  return (
    <svg
      fill="red"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      data-name="Layer 1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <title></title>
        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path>
      </g>
    </svg>
  );
};
const PasswordValidation = ({ passWordValidation }) => {
  const [showValidation, setShowValidation] = useState(false);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const allTrue = Object.values(passWordValidation).every((value) => value);
    setShowValidation(allTrue);
  }, [passWordValidation]);

  return (
    <div
      style={{
        border: showValidation ? '1px solid #03aa49' : '1px solid red',
        borderRadius: '5px',
        padding: '5px',
        marginTop: '5px',
        // width:"80%",
      }}
    >
      <Stack direction={'row'}>
        <Box
          sx={{
            // marginRight: "10px",
            width: matchessm ? '10px' : '20px',
            height: matchessm ? '10px' : '20px',
          }}
        >
          <LockSign
            color={showValidation ? '#03aa49' : 'red'}
            size={matchessm ? '10px' : '15px'}
          />
        </Box>
        <Typography
          sx={{
            fontSize: matchessm ? '10px' : '12px',
            fontWeight: 500,
            fontFamily: 'poppins',
          }}
        >
          Your Password needs to:
        </Typography>
      </Stack>
      <Stack direction={'row'}>
        <Box
          sx={{
            // marginRight: "10px",
            width: matchessm ? '10px' : '20px',
            height: matchessm ? '10px' : '20px',
          }}
        ></Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              marginRight: '5px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {passWordValidation?.minimumLength ? (
              <TickSign size={matchessm ? '10px' : '15px'} />
            ) : (
              <WrongSign size={matchessm ? '10px' : '15px'} />
            )}
          </Box>
          <Typography
            sx={{
              fontSize: matchessm ? '8px' : '12px',
              fontWeight: 400,
              fontFamily: 'poppins',
              color: passWordValidation?.minimumLength ? '#03aa49' : 'black',
            }}
          >
            minimum 8 characters
          </Typography>
        </Box>
      </Stack>
      <Stack direction={'row'}>
        <Box
          sx={{
            // marginRight: "10px",
            width: matchessm ? '10px' : '20px',
            height: matchessm ? '10px' : '20px',
          }}
        ></Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              marginRight: '5px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {passWordValidation?.capitalCase &&
            passWordValidation?.lowerCase ? (
              <TickSign size={matchessm ? '10px' : '15px'} />
            ) : (
              <WrongSign size={matchessm ? '10px' : '15px'} />
            )}
          </Box>
          <Typography
            sx={{
              fontSize: matchessm ? '8px' : '12px',
              fontWeight: 400,
              fontFamily: 'poppins',
              color:
                passWordValidation?.capitalCase && passWordValidation?.lowerCase
                  ? '#03aa49'
                  : 'black',
            }}
          >
            include both lower and upper case characters
          </Typography>
        </Box>
      </Stack>
      <Stack direction={'row'}>
        <Box
          sx={{
            // marginRight: "10px",
            width: matchessm ? '10px' : '20px',
            height: matchessm ? '10px' : '20px',
          }}
        ></Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              marginRight: '5px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {passWordValidation?.number ? (
              <TickSign size={matchessm ? '10px' : '15px'} />
            ) : (
              <WrongSign size={matchessm ? '10px' : '15px'} />
            )}
          </Box>
          <Typography
            sx={{
              fontSize: matchessm ? '8px' : '12px',
              fontWeight: 400,
              fontFamily: 'poppins',
              color: passWordValidation?.number ? '#03aa49' : 'black',
            }}
          >
            include at least one number
          </Typography>
        </Box>
      </Stack>
      <Stack direction={'row'}>
        <Box
          sx={{
            // marginRight: "10px",
            width: matchessm ? '10px' : '20px',
            height: matchessm ? '10px' : '20px',
          }}
        ></Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              marginRight: '5px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {passWordValidation?.specialCharacter ? (
              <TickSign size={matchessm ? '10px' : '15px'} />
            ) : (
              <WrongSign size={matchessm ? '10px' : '15px'} />
            )}
          </Box>
          <Typography
            sx={{
              fontSize: matchessm ? '8px' : '12px',
              fontWeight: 400,
              fontFamily: 'poppins',
              color: passWordValidation?.specialCharacter ? '#03aa49' : 'black',
            }}
          >
            include at least one special character
          </Typography>
        </Box>
      </Stack>
    </div>
  );
};

export default PasswordValidation;
